import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LINK_PATH } from '../../../../constant';
import { useDropdownKeyboardNavigation } from '../../../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import NavigationList from '../../../../components/NavigationList/NavigationList';
import useKeyboardNavigation from '../../../../components/Custom_Hooks/useKeyboardNavigation';

const AccountBook =()=> {
    
    const navigate = useNavigate();
    const location = useLocation();
    
    const keyMap = {
        'c': '',
        'l': (nav) => nav('/ledgerbook', { state: { resetId: Date.now() } }),
        'g': '',
        'v': '',
        't': '',
        'y': '',
        'r': '',
        's': '',
        'p': '',
        'j': '',
        'd': '',
        'e': '',
        'u': '',
    };
    
    useKeyboardNavigation(keyMap);
   
    const data = [
        { to: '/createmasters', text: 'Cash/Bank Book(s)' },
        { to: '/ledgerbook', text: 'Ledger', state: { resetId: Date.now() } },
        { to: '/chartofaccountmasters', text: 'Group Summary' },
        { to: '/chartofaccountmasters', text: 'Group Vouchers' },
        { to: '/voucherstransaction', text: 'Contra Register' },
        { to: '/daybooktransaction', text: 'Payment Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Receipt Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Sales Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Purchase Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Journal Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Debit Note Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Credit Note Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Voucher Clarification', state: { resetId: Date.now() } }
    ];
    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: data,
        state: true,
        onItemSelect: (item) => {
            if (['/ledgerbook', '/current_date', '/period'].includes(location.pathname)) {
                return;
            }
            if (item.state) {
                navigate(item.to, { state: item.state })
            } else {
                navigate(item.to)
            }
        },

    });
    return (
        <NavigationList
            data={data}
            selectedItemIndex={selectedItemIndex}
            setSelectedItemIndex={setSelectedItemIndex}
            title='Account Books'
            first_heading='SUMMARY'
            secound_heading='REGISTERS'
        />
    )
}

export default React.memo(AccountBook);
